module.exports = __webpack_public_path__ + "assets/img/pop-1.85edd01e.jpg";